import { Component, EventEmitter, Input, Output, OnChanges, HostListener, HostBinding, SimpleChanges, Renderer2, OnInit, AfterViewInit, Inject, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute , Router, NavigationEnd, ResolveEnd, ActivatedRouteSnapshot,
  RouterStateSnapshot, RouterState } from '@angular/router';
import { SafeHtml, SafeResourceUrl, DOCUMENT, DomSanitizer } from '@angular/platform-browser';

import { SymptomDetailsService } from './../services/symptom-details-service';
import { SuggestDiagnosisService } from './../services/suggest-diagnosis.service';

@Component({
  selector: 'app-article-trail-details',
  templateUrl: './article-details.component.html',
  styleUrls: ['./article-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ArticleDetailsComponent implements OnInit {
  private _ArticleDetails = '';
  renderer2: Renderer2;
  @Output() onBackToSymptomDetails = new EventEmitter<String>();
  // @Input() whereToQueryParams: any;

  @Input()
  set ArticleDetails(ArticleDetails: any){
      this._ArticleDetails = ArticleDetails;
  }
  get ArticleDetails(): any{
    return this._ArticleDetails;
  }

  constructor(
      private ActRoute: ActivatedRoute,
      private router: Router,
      private SymptomDetailsService: SymptomDetailsService,
      private SuggestDiagnosisService: SuggestDiagnosisService,
      private sanitizer: DomSanitizer,
      el: ElementRef,
      @Inject(DOCUMENT) private document: any,
      renderer: Renderer2
    ) {
      this.renderer2 = renderer;
    }

  ngOnInit() {
  }

  public backToSymptomDetails(): void {
    this.onBackToSymptomDetails.emit();
    this.SuggestDiagnosisService.onTriggerTrackingEvent('DIAGNOSIS DETAILS', null);
  }

  // public onWhereNow(): void {
  //   // console.log(this.whereToQueryParams);
  //   if (this.whereToQueryParams !== undefined) {
  //     this.router.navigate(['/where-to-go-tool'], { queryParams: this.whereToQueryParams });
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/app/article-details/article-details.component.ts